
document.addEventListener('click', function() {
    console.log('Click detected!');
});


document.addEventListener('DOMContentLoaded', function () {
    // Ensure the Shopify.Cart object is available
    if (window.Shopify && window.Shopify.Cart) {
        console.log('Shopify.Cart object is available.');

        // Function to check the cart for items of size "6x6"
        function checkCartForSize() {
            fetch('/cart.js')  // Fetch the current cart in JSON format
                .then(response => response.json())
                .then(cart => {
                    let sizeCount = 0;
                    const minQuantity = 10;  // Minimum quantity required for size "6x6"

                    // Loop through the cart items and check for size "6x6"
                    cart.items.forEach(item => {
                        if (item.properties._Size === "6x6") {
                            sizeCount += item.quantity;
                        }
                    });

                    // If there are fewer than 10 items of size "6x6", show an alert and disable checkout
                    if (sizeCount < minQuantity) {
                        alert('You need at least 10 items of size 6x6 in your cart before proceeding to checkout.');
                        document.querySelector('.checkout-button').disabled = true;  // Disable checkout button
                    } else {
                        document.querySelector('.checkout-button').disabled = false;  // Enable checkout button
                    }
                })
                .catch(error => console.error('Error fetching cart:', error));
        }

        // Listen for the 'Add to Cart' button click
        document.querySelectorAll('.add-to-cart-button').forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault(); // Prevent default behavior for testing
                const variantId = 12345;  // Replace with the actual variant ID
                const quantity = 1;       // Quantity to add

                // Perform the AJAX request to add an item to the cart
                fetch('/cart/add.js', {
                    method: 'POST',
                    body: JSON.stringify({
                        id: variantId,  // Variant ID to add to the cart
                        quantity: quantity
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log('Item added to cart:', data);

                        // After adding the item, check the cart content
                        checkCartForSize();
                    })
                    .catch(error => console.error('Error adding item to cart:', error));
            });
        });
    } else {
        console.log('Shopify.Cart object is not available.');
    }
});

